import Singapore from "../../assets/logo/country/singapore.png";
import UK from "../../assets/logo/country/uk.png";
import Australia from "../../assets/logo/country/australia.png";
import PSB from "../../assets/images/psb-academy.webp";
import Kaplan from "../../assets/images/kaplan-singapore.webp";
import Amity from "../../assets/images/amity-global-institute.webp";
import EAIM from "../../assets/images/eaim.webp";
import MDIS from "../../assets/images/mdis-singapore.webp";
import Teesside from "../../assets/images/teesside-university.webp";
import UOSW from "../../assets/images/university-of-south-wales.webp";
import UOS from "../../assets/images/university-of-sunderland.webp";
import UWE from "../../assets/images/uwe-bristol.webp";
import UOH from "../../assets/images/university-of-huddersfield.webp";
import UON from "../../assets/images/university-of-northampton.webp";
import Coventry from "../../assets/images/coventry-university.webp";

export const featuredUniversities = [
  {
    id: 1,
    name: "PSB Academy",
    image: PSB,
    country: "新加坡",
    description:
      "PSB 学院是新加坡的一所私立教育机构，提供商业、信息技术、工程及健康科学等领域的大专、本科及研究生课程，并与多所国际大学合作办学。",
    scholarship: "Merit Scholarships",
    color: "from-blue-400 to-cyan-500",
  },
  {
    id: 2,
    name: "Amity Global Institute",
    image: Amity,
    country: "新加坡",
    description:
      "Amity Global Institute 是新加坡的一所私立教育机构，提供商业、信息技术、工程及健康科学等领域的大专、本科及研究生课程，并与多所国际大学合作办学。",
    scholarship: "Up to 30% Scholarship",
    color: "from-indigo-400 to-blue-500",
  },
  {
    id: 3,
    name: "Teesside University",
    image: Teesside,
    country: "英国",
    description:
      "Teesside University 是英国的一所私立教育机构，提供商业、信息技术、工程及健康科学等领域的大专、本科及研究生课程，并与多所国际大学合作办学。",
    scholarship: "Merit & Need-Based",
    color: "from-red-400 to-pink-500",
  },
  {
    id: 4,
    name: "Coventry University",
    image: Coventry,
    country: "英国",
    description:
      "Coventry University 是英国的一所私立教育机构，提供商业、信息技术、工程及健康科学等领域的大专、本科及研究生课程，并与多所国际大学合作办学。",
    scholarship: "Early Bird Scholarships",
    color: "from-purple-400 to-indigo-500",
  },
];

export const destinations = [
  {
    country: "新加坡",
    flag: Singapore,
    description: "快速完成学业，就业市场强劲，距离家乡近。",
    universities: "PSB, Kaplan, Amity",
    color: "from-red-400 to-pink-500",
  },
  {
    country: "英国",
    flag: UK,
    description: "1 年制硕士、3 年制学位课程，文凭全球认可。",
    universities: "Teesside, UWE, Coventry",
    color: "from-blue-400 to-indigo-500",
  },
];

export const benefits = [
  {
    title: "更高额奖学金",
    description: "部分大学提供基于成绩及早鸟申请的奖学金。",
    emoji: "🏆",
  },
  {
    title: "额外回扣优惠",
    description: "SCS Education 申请者可享独家回扣（依大学而定）。",
    emoji: "💰",
  },
  {
    title: "快速申请流程",
    description: "文件只需提交一次，其余流程由我们全程高效处理。",
    emoji: "⚡",
  },
  {
    title: "签证与住宿支援",
    description: "提供签证申请、出发前说明会及住宿安排的一站式指导。",
    emoji: "✈️",
  },
  {
    title: "值得信赖的海外升学合作伙伴",
    description: "拥有数千名学生成功升学的真实成果与口碑。",
    emoji: "🌟",
  },
  {
    title: "快速且个性化的升学指导",
    description: "我们深入了解您的成绩、偏好与目标，为您精准匹配最合适的大学。",
    emoji: "🎯",
  },
  {
    title: "零收费服务",
    description: "我们的升学咨询服务对学生 100% 完全免费。",
    emoji: "🆓",
  },
  {
    title: "一站式全程支援",
    description: "从申请、签证、住宿到奖学金，全流程由我们为您处理。",
    emoji: "🤝",
  },
];

export const testimonials = [
  {
    name: "Chai Jiong Xian",
    destination: "United Kingdom 🇬🇧",
    quote:
      "They've been with me every step of the way, making the process smooth and stress-free. Here's to a bright future, thanks to SCS Education!",
    uni: "University of Sunderland",
    color: "bg-gradient-to-br from-teal-100 to-cyan-100",
  },
  {
    name: "Anonymous",
    destination: "Singapore 🇸🇬",
    quote:
      "Thank you SCS Dolly recommended me to go Singapore study, and I get scholarships too! Highly recommend SCS to every students!",
    uni: "",
    color: "bg-gradient-to-br from-red-100 to-pink-100",
  },
  {
    name: "Tan Jun An",
    destination: "United Kingdom 🇬🇧",
    quote:
      "I am saying thanks to each and every staff in SCS Education for their kindness and care. You are really awesome!!!",
    uni: "UWE Bristol",
    color: "bg-gradient-to-br from-blue-100 to-indigo-100",
  },
];

export const faqs = [
  {
    question: "我该如何申请海外大学？",
    answer:
      "只需将您的 SPM/UEC 成绩发送给我们，我们将为您筛选合适的大学，并全程指导申请流程。",
  },
  {
    question: "你们的升学咨询服务是免费的吗？",
    answer: "是的 —— SCS Education 为所有学生提供 100% 免费的升学支持服务。",
  },
  {
    question: "我需要准备哪些文件？",
    answer: "SPM/UEC 成绩、护照复印件、离校证书，以及成绩单（如适用）。",
  },
  {
    question: "整个申请流程需要多久？",
    answer: "部分大学可在 3–10 个工作日内发放录取通知书。",
  },
  {
    question: "我需要先决定要读的课程吗？",
    answer: "不一定 —— 我们会根据您的兴趣与成绩，协助您一起探索最适合的选择。",
  },
];

export const overseasUniversities = [
  {
    name: "PSB",
    image: PSB,
    fullName: "PSB Academy",
    location: "Singapore",
    ranking: "新加坡排名第 22",
    scholarships: "5 项奖学金",
    employment: "毕业生就业率 85%",
    description:
      "PSB 学院是新加坡的一所私立教育机构，提供商业、信息技术、工程及健康科学等领域的大专、本科及研究生课程，并与多所国际大学合作办学。",
    courses: [
      { name: "工商管理文凭", fee: "SGD 7,673" },
      { name: "运动与运动科学文凭", fee: "SGD 7,673" },
      { name: "媒体 / 传播相关文凭", fee: "SGD 7,673" },
    ],
    color: "from-blue-400 to-cyan-500",
  },
  {
    name: "Kaplan",
    image: Kaplan,
    fullName: "Kaplan International Pathway Singapore",
    location: "Singapore",
    ranking: "全球认可",
    scholarships: "7 项奖学金",
    employment: "毕业生就业率 70%",
    description:
      "Kaplan 新加坡是一所私立教育机构，与国际大学合作提供商业、信息技术、会计、法律及心理学等领域的大专、本科及研究生课程。",
    courses: [
      { name: "心理学文凭", fee: "SGD 7,466" },
      { name: "会计与金融文凭", fee: "SGD 6,540" },
      { name: "金融与商业分析文凭", fee: "SGD 5,450" },
    ],
    color: "from-indigo-400 to-blue-500",
  },
  {
    name: "Amity",
    image: Amity,
    fullName: "Amity Global Institute",
    location: "Singapore",
    ranking: "新加坡排名第一的英国 MBA",
    scholarships: "8 项奖学金",
    employment: "毕业生就业率 75%",
    description:
      "Amity 全球学院是新加坡的一所私立教育机构，与国际大学合作，提供商业、信息技术及管理相关课程。",
    courses: [
      { name: "工商管理文凭", fee: "SGD 7,500" },
      { name: "会计与金融文凭", fee: "SGD 7,500" },
      { name: "计算机 / 信息技术文凭", fee: "SGD 7,500" },
      {
        name: "酒店管理 / 酒店与旅游管理文凭",
        fee: "SGD 6,000",
      },
    ],
    color: "from-red-400 to-pink-500",
  },
  {
    name: "EAIM",
    image: EAIM,
    fullName: "East Asia Institute of Management",
    location: "Singapore",
    ranking: "全球接轨的商业教育",
    scholarships: "10 项奖学金",
    employment: "毕业生就业率 95%",
    description:
      "东亚管理学院（EAIM）是新加坡的私立学府，以价格亲民且通过英国大学合作提供商业相关课程而闻名。",
    courses: [
      { name: "商业与管理文凭", fee: "SGD 6,280" },
      { name: "商业与会计文凭", fee: "SGD 6,280" },
      {
        name: "国际酒店与旅游管理文凭",
        fee: "SGD 6,280",
      },
      { name: "高级文凭", fee: "SGD 7,310" },
    ],
    color: "from-purple-400 to-indigo-500",
  },
  {
    name: "MDIS",
    image: MDIS,
    fullName: "Management Development Institute of Singapore",
    location: "Singapore",
    ranking: "全球排名中等",
    scholarships: "6 项奖学金",
    employment: "毕业生就业率 78%",
    description:
      "新加坡管理发展学院（MDIS）是一所历史悠久的私立学府，与国际大学合作，提供商业、媒体、信息技术、健康科学及酒店管理课程。",
    courses: [
      {
        name: "商业与管理 文凭 / 高级文凭",
        fee: "SGD 7,900",
      },
      { name: "酒店与旅游管理", fee: "SGD 6,700" },
      { name: "媒体、传播与创意设计", fee: "SGD 32,000" },
      { name: "工程 / 科技 / 信息技术", fee: "SGD 40,000" },
    ],
    color: "from-teal-400 to-cyan-500",
  },
  {
    name: "Teesside",
    image: Teesside,
    fullName: "Teesside University",
    location: "United Kingdom",
    ranking: "QS 世界排名 601–800",
    scholarships: "7 项奖学金",
    employment: "毕业生就业率 95%",
    description:
      "Teesside大学是英国的一所大学，以商业、计算机、工程、健康及创意艺术等行业导向课程闻名，注重实务与就业能力。",
    courses: [
      { name: "商业与管理", fee: "GBP 17,000" },
      { name: "计算机 / 信息技术 / 工程", fee: "GBP 17,000" },
      { name: "研究生课程", fee: "GBP 17,000" },
      { name: "基础课程 / 预科课程", fee: "GBP 15,500" },
    ],
    color: "from-orange-400 to-red-500",
  },
  {
    name: "USW",
    image: UOSW,
    fullName: "University of South Wales",
    location: "United Kingdom",
    ranking: "英国排名第 51",
    scholarships: "8 项奖学金",
    employment: "毕业生就业率 96%",
    description:
      "南威尔士大学（USW）是一所英国大学，提供多元本科与研究生课程，涵盖商业、工程、创意艺术及健康科学，并强调实践与产业连接。",
    courses: [
      { name: "商业 / 创意产业", fee: "GBP 15,850" },
      {
        name: "计算机 / 工程 / 科学 / 教育相关",
        fee: "GBP 16,200",
      },
      { name: "法律 / 法学相关领域", fee: "GBP 16,900" },
      { name: "研究生学位", fee: "GBP 16,900" },
    ],
    color: "from-violet-400 to-purple-500",
  },
  {
    name: "UOS",
    image: UOS,
    fullName: "University of Sunderland",
    location: "United Kingdom",
    ranking: "英国排名第 27",
    scholarships: "9 项奖学金",
    employment: "毕业生就业率 95%",
    description:
      "Sunderland大学是一所英国大学，提供广泛的本科与研究生课程，强调就业能力、实践技能及国际合作。",
    courses: [
      {
        name: "商业 / 管理 / 会计与金融",
        fee: "GBP 16,500",
      },
      {
        name: "计算机 / 信息技术 / 工程 / 计算机科学",
        fee: "GBP 16,500",
      },
      {
        name: "健康 / 护理 / 相关医疗学位",
        fee: "GBP 16,500",
      },
      { name: "研究生课程", fee: "GBP 17,000" },
    ],
    color: "from-purple-400 to-pink-500",
  },
  {
    name: "UWE",
    image: UWE,
    fullName: "University of the West of England",
    location: "United Kingdom",
    ranking: "英国排名第 39",
    scholarships: "6 项奖学金",
    employment: "毕业生就业率 92%",
    description:
      "西英格兰大学（UWE Bristol）以其在商业、工程、健康及创意产业方面的专业与职业导向课程闻名，并注重就业能力与业界合作。",
    courses: [
      {
        name: "商业 / 商业管理 / 会计与金融",
        fee: "GBP 16,000",
      },
      {
        name: "工程 / 设计 / 环境 / 计算机与信息技术",
        fee: "GBP 16,500",
      },
      {
        name: "健康科学 / 护理 / 辅助医疗 / 应用健康科学",
        fee: "GBP 16,750",
      },
      { name: "研究生学位", fee: "GBP 16,000" },
    ],
    color: "from-pink-400 to-rose-500",
  },
  {
    name: "Huddersfield",
    image: UOH,
    fullName: "University of Huddersfield",
    location: "United Kingdom",
    ranking: "QS 世界排名第 524",
    scholarships: "7 项奖学金",
    employment: "毕业生就业率 98%",
    description:
      "Huddersfield大学以工程、商业、媒体及健康等紧密衔接产业的课程闻名，强调实务学习与就业能力。",
    courses: [
      {
        name: "商业 / 管理 / 会计与金融 / 市场营销",
        fee: "GBP 15,500",
      },
      { name: "工程 / 计算机 / 科学 / 信息技术", fee: "GBP 15,500" },
      { name: "健康科学 / 辅助医疗", fee: "GBP 15,500" },
      {
        name: "艺术 / 设计 / 媒体 / 创意与人文",
        fee: "GBP 15,500",
      },
    ],
    color: "from-amber-400 to-orange-500",
  },
  {
    name: "UON",
    image: UON,
    fullName: "University of Northampthon",
    location: "United Kingdom",
    ranking: "英国排名第 119",
    scholarships: "5 项奖学金",
    employment: "毕业生就业率 96%",
    description:
      "Northampton大学是一所英国大学，以高就业率、创新教学及商业、健康、教育与社会科学等专业课程著称。",
    courses: [
      { name: "商业与管理", fee: "GBP 15,200" },
      { name: "计算机科学 / 信息技术", fee: "GBP 15,200" },
      { name: "健康与护理", fee: "GBP 15,200" },
    ],
    color: "from-blue-400 to-cyan-500",
  },
  {
    name: "Coventry",
    image: Coventry,
    fullName: "Coventry University",
    location: "United Kingdom",
    ranking: "QS 世界排名 2025 年第 531",
    scholarships: "7 项奖学金",
    employment: "毕业生就业率 95%",
    description:
      "Coventry大学以其行业导向课程、卓越就业成果及全球合作网络闻名，涵盖商业、工程、健康及创意学科。",
    courses: [
      { name: "工程 / 计算机 / 科学", fee: "GBP 18,600" },
      { name: "商业与管理", fee: "GBP 16,800" },
      { name: "健康与生命科学", fee: "GBP 18,000" },
    ],
    color: "from-indigo-400 to-blue-500",
  },
];

export const footerData = {
  aboutTitle: "关于 SCS Education",
  aboutDesc:
    "SCS Education 是马来西亚领先的一站式教育服务中心，专为SPM、O-Level、STPM、UEC 和 A-Level 学生提供指导——包括课程咨询、大学资讯、奖学金申请协助以及职业规划等服务。",
  partnerUniTitle: "合作大学",
  partnerUni: [
    "PSB",
    "Kaplan",
    "Amity",
    "EAIM",
    "MDIS",
    "Teesside",
    "USW",
    "UOS",
    "UWE",
    "Huddersfield",
    "UON",
    "Coventry",
  ],
  contactTitle: "联系信息",
  contact: [
    "📞 电话: 011-12870256",
    "✉️ 邮箱: ng.scseducation@gmail.com",
    "📌 办公室: Kuantan (HQ), Shah Alam, Sitiawan",
  ],
};
